/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const Location: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 24 24" size={size} color={color} {...props}>
      <path d="M12 2a7 7 0 00-7 7c0 3.966 4.404 9.82 6.226 12.071a.994.994 0 001.548 0C14.596 18.82 19 12.966 19 9a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" />
    </Icon>
  );
};

export default Location;

Location.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
